/**
 * TanStack Query hooks for `link-management-crud-permission-scope`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linkManagementCrudPermissionScopeQueryKeys,
	type CreateLinkManagementCrudPermissionScopeBody,
	type ListLinkManagementCrudPermissionScopeResponse,
	type LinkManagementCrudPermissionScopeRow,
} from "./api";

export function useLinkManagementCrudPermissionScopeList(): UseQueryResult<ListLinkManagementCrudPermissionScopeResponse, Error> {
	return useQuery({
		queryKey: linkManagementCrudPermissionScopeQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinkManagementCrudPermissionScopeCreate(): UseMutationResult<LinkManagementCrudPermissionScopeRow, Error, CreateLinkManagementCrudPermissionScopeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkManagementCrudPermissionScopeQueryKeys.all });
		},
	});
}

export function useLinkManagementCrudPermissionScopeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkManagementCrudPermissionScopeQueryKeys.all });
		},
	});
}
